'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PubExchange
     *
     * This web component will lazy inject the PubExchange script
     * once the component is scrolled into view.
     *
     * This component is part of pubExchange template module.
     * /server/web/template-modules/pubExchange
     */
    class PubExchange extends pageClass.PhoenixElement {
        connectedCallback() {
            super.connectedCallback();

            this.canRender().then((canRender) => {
                if (canRender) {
                    this.pubExchangeId = this.getAttr('pub-exchange-id', { required: true });
                    this.pubExchangeModuleId = this.getAttr('pub-exchange-module-id', {
                        required: false,
                    });
                    this.observeFirstIntersection();
                } else {
                    // If the user has Premium, or GDPR is applicable, don't load PubExchange.
                    this.setAttribute('aria-hidden', true);
                    this.style.display = 'none';
                }
            });
        }

        onFirstIntersection() {
            var src;
            if (this.pubExchangeModuleId) {
                window.PUBX = window.PUBX || { pub: this.pubExchangeId, discover: true };
                src = 'https://main.pubexchange.com/loader.min.js';
            } else {
                src = 'https://cdn.pubexchange.com/modules/partner/' + this.pubExchangeId;
            }

            pageClass.util.addScriptResource(src).then(() => {
                this.firstChild.classList.remove('is-waiting-to-load');
            });
        }
    }

    window.customElements.define('phoenix-pub-exchange', PubExchange);
});
